import { render } from "./CommonPaginator.vue?vue&type=template&id=94d360c4"
import script from "./CommonPaginator.vue?vue&type=script&lang=js"
export * from "./CommonPaginator.vue?vue&type=script&lang=js"

import "./CommonPaginator.vue?vue&type=style&index=0&id=94d360c4&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__